export function usePassUsers() {
  return async (legacyApp: any) => {
    await legacyApp.$store.dispatch('people/init')
  }
}
